(function () {
  "use strict";

  var soportaIO = typeof IntersectionObserver === "function";

  var io = soportaIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }) : null;

  // Revela de inmediato, sin esperar al scroll. Lo usa el AJAX del filtro de
  // colecciones y el editor de temas, donde el observer ya corrio y no ve
  // los nodos que llegan despues por fetch.
  function revelar(raiz) {
    var r = raiz || document;
    if (r.classList && r.classList.contains("rev")) r.classList.add("in");
    if (r.querySelectorAll) {
      r.querySelectorAll(".rev").forEach(function (el) { el.classList.add("in"); });
    }
  }
  window.fcRevelar = revelar;

  // Pone bajo observacion los .rev que aun no se han revelado.
  function observar(raiz) {
    var r = raiz || document;
    if (!io) { revelar(r); return; }
    if (r.classList && r.classList.contains("rev") && !r.classList.contains("in")) io.observe(r);
    if (r.querySelectorAll) {
      r.querySelectorAll(".rev:not(.in)").forEach(function (el) { io.observe(el); });
    }
  }
  observar(document);

  var toast = document.getElementById("toast");
  var toastTxt = document.getElementById("toastTxt");
  var toastT = null;
  function ping(msg) {
    if (!toast) return;
    toastTxt.textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.classList.remove("show"); }, 2400);
  }

  function money(cents) {
    return "$" + (cents / 100).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function updRenta() {
    var box = document.querySelector("[data-renta]");
    if (!box) return;
    var out = document.getElementById("rentaQtyOut");
    var tot = document.getElementById("rentaTotal");
    var lbl = document.getElementById("rentaTotalLbl");
    if (!out || !tot) return;
    var qty = parseInt(out.textContent, 10) || 0;
    var precio = parseInt(box.getAttribute("data-precio"), 10) || 0;
    tot.textContent = money(qty * precio);
    if (lbl) lbl.textContent = "+ IVA al mes por " + qty + " piezas";
  }
  updRenta();

  // Editor de temas: cada cambio de ajuste reemplaza la seccion por AJAX.
  // Los nodos nuevos nacen en opacity:0 y el observer inicial ya no los ve,
  // asi que en el editor se revelan de golpe y se recalculan los totales.
  var enEditor = !!(window.Shopify && window.Shopify.designMode);
  document.addEventListener("shopify:section:load", function (e) {
    if (enEditor) revelar(e.target); else observar(e.target);
    updRenta();
  });
  document.addEventListener("shopify:section:select", function (e) { if (enEditor) revelar(e.target); });
  document.addEventListener("shopify:section:reorder", function () { if (enEditor) revelar(document); });
  document.addEventListener("shopify:block:select", function (e) { if (enEditor) revelar(e.target); });

  function setBadge(n) {
    var b = document.getElementById("cartCount");
    if (!b) return;
    b.textContent = n;
    b.classList.toggle("is-empty", n === 0);
  }

  document.addEventListener("click", function (ev) {

    var q = ev.target.closest("[data-qty]");
    if (q) {
      var out = document.getElementById(q.getAttribute("data-target") || "qtyOut");
      if (!out) return;
      var step = parseInt(q.getAttribute("data-step"), 10) || 1;
      var min = parseInt(q.getAttribute("data-min") || "1", 10);
      var n = Math.max(min, (parseInt(out.textContent, 10) || min) + step);
      out.textContent = n;
      if (out.id === "rentaQtyOut") updRenta();
      return;
    }

    var th = ev.target.closest("[data-thumb]");
    if (th) {
      var main = document.getElementById("galMain");
      if (main) main.src = th.getAttribute("data-thumb");
      document.querySelectorAll("[data-thumb]").forEach(function (t) { t.classList.remove("act"); });
      th.classList.add("act");
      return;
    }

    var add = ev.target.closest("[data-add]");
    if (add && !add.disabled) {
      var variant = parseInt(add.getAttribute("data-variant"), 10);
      if (!variant) return;
      var qty = 1;
      var outId = add.getAttribute("data-out");
      if (outId) {
        var o = document.getElementById(outId);
        if (o) qty = parseInt(o.textContent, 10) || 1;
      }
      add.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variant, quantity: qty }] })
      })
        .then(function (r) { if (!r.ok) throw new Error("add"); return fetch("/cart.js"); })
        .then(function (r) { return r.json(); })
        .then(function (c) { setBadge(c.item_count); ping("Agregado al carrito"); })
        .catch(function () { ping("No se pudo agregar. Intente de nuevo."); })
        .finally(function () { add.disabled = false; });
      return;
    }
  });

  document.addEventListener("change", function (ev) {
    var s = ev.target.closest("[data-sort]");
    if (s) {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", s.value);
      window.location.href = url.toString();
      return;
    }
    var vs = ev.target.closest("[data-varsel]");
    if (vs) {
      var opt = vs.options[vs.selectedIndex];
      document.querySelectorAll('[data-add][data-out="qtyOut"]').forEach(function (b) {
        b.setAttribute("data-variant", vs.value);
      });
      var p = document.getElementById("pdpPrice");
      if (p && opt.getAttribute("data-price")) p.textContent = opt.getAttribute("data-price");
      return;
    }
  });

  var sticky = document.querySelector("[data-autoshow]");
  if (sticky) setTimeout(function () { sticky.classList.add("is-show"); }, 500);
})();
